<div *ngIf="event" class="d-flex mt-2 justify-content-between flex-wrap flex-md-nowrap align-items-center">
  <h1 class="h2">Badges: {{ event.name }}</h1>
  <div class="btn-toolbar">
  </div>
</div>

<i>Badges can only be displayed for published results</i>

<hr />

<input type="button" class="btn btn-primary" value="Issue All badges" (click)="issueAllBadges()" />

<hr />
<div *ngIf="skillCollection && resultCollection">
  <div class="row" *ngFor="let skill of skillCollection.skills" style="margin-top: 10px;">
    <div class="col-sm-12">
        <button class="btn btn-primary" (click)="issueBadgesForSkill(skill)">Issue Badges {{ skill.number }} {{ skill.name.text }}</button>
      <div class="row" style="border-bottom: 2px solid #000;">
        <div class="col-sm-1 font-weight-bold">Member</div>
        <div class="col-sm-3 font-weight-bold">Name(s)</div>
        <div class="col-sm-2 font-weight-bold">Medal(s)</div>
        <div class="col-sm-4 font-weight-bold">Badges(s)</div>
        <div class="col-sm-2 font-weight-bold">Actions</div>
      </div>
      <div class="row" *ngFor="let result of getResultsForSkill(skill)" style="border-bottom: 1px solid #000;">
        <div class="col-sm-1">
          {{ result.member.code }}
        </div>
        <div class="col-sm-3">
          <div *ngFor="let competitor of result.competitors">
            {{ competitor.first_name }} {{ competitor.last_name }} ({{ competitor.person_id }})
          </div>
        </div>
        <div class="col-sm-2">
          <div *ngIf="result.medal">
            {{ result.medal.name.text }}
          </div>
        </div>
        <div class="col-sm-4">
          <div>
            {{ event.name }} - Champion - {{ skill.name.text }} ({{ getBadgeState(result, event.name + ' - Champion - ' + skill.name.text) }})
          </div>
          <div *ngIf="result.medal && result.medal.name.text.includes('Medallion')">
            {{ event.name }} - Medallion for Excellence - {{ skill.name.text }} ({{ getBadgeState(result, event.name + ' - Medallion for Excellence - ' + skill.name.text) }})
          </div>
          <div *ngIf="result.medal && !result.medal.name.text.includes('Medallion')">
            {{ event.name }} - {{ result.medal.name.text }} Medallist - {{ skill.name.text }} ({{ getBadgeState(result, event.name + ' - ' + result.medal.name.text + ' Medallist - ' + skill.name.text) }})
          </div>
          <div *ngIf="result.best_of_nation">
            {{ event.name }} - Best of Nation ({{ getBadgeState(result, event.name + ' - Best of Nation') }})
          </div>
          <div *ngIf="result.albert_vidal_award">
            {{ event.name }} - Albert Vidal Award ({{ getBadgeState(result, event.name + ' - Albert Vidal Award') }})
          </div>

        </div>
        <div class="col-sm-2">
          <input *ngIf="showIssueAllBadgesForSkill(result, event.name + ' - Champion - ' + skill.name.text)" type="button" class="btn btn-primary" value="Issue badges" (click)="issueAllBadgesForPerson(result)" />
        </div>
      </div>
    </div>

  </div>
</div>
